module.exports = __webpack_public_path__ + "static/media/lv.static.5bed6d50.svg";